import { createSlice } from '@reduxjs/toolkit';

const INIT_STATE = {
  activeName: '',
  props: {},
};

const openModalHandler = (state, payload) => {
  if (typeof payload === 'string') {
    state.activeName = payload;
  } else if (typeof payload === 'object') {
    state.activeName = payload.activeName;
    state.props = payload.props;
  }

  document.body.classList.add('overflow-hidden');
};

const closeModalHandler = (state) => {
  state.activeName = '';
  state.props = {};

  document.body.classList.remove('overflow-hidden');
};

const modalSlice = createSlice({
  name: 'modal',
  initialState: INIT_STATE,
  reducers: {
    openModal: (state, action) => openModalHandler(state, action.payload),
    closeModal: (state) => closeModalHandler(state),
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
